import BoardContentEventApi from '@app/api/public/BoardContentEventApi';
import { useMutation, useQueryClient } from 'react-query';
import { memberEventQueryKeys } from './boardEventQueries';

type Variables = { id: number; notify: boolean };

const usePublishEvent = () => {
    const client = useQueryClient();
    return useMutation(
        (varables: Variables) => {
            return BoardContentEventApi.publishEvent(varables);
        },
        {
            onSettled: () => {
                client.invalidateQueries(memberEventQueryKeys.all);
            },
        }
    );
};

export default usePublishEvent;
